// Fonctions pures de l'écran Catalogue (marques et produits), testables sans charger les pages.

export const FILTRES = [
    {cle: "tous", titre: "Tous"},
    {cle: "publies", titre: "Publiés"},
    {cle: "masques", titre: "Masqués"},
    {cle: "sansPrestation", titre: "Sans prestation publiée"},
    {cle: "sansPhoto", titre: "Sans photo"},
    {cle: "doublons", titre: "Doublons"},
];

export function normaliser(texte) {
    return (texte ?? "")
        .toString()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
}

export function nombrePrestations(produit) {
    return produit?.prestations?.length ?? 0;
}

export function aUnePhoto(produit) {
    return Boolean(produit?.asset || produit?.asset_id || produit?.photo);
}

// Identifiants des produits qui portent le même nom qu'un autre produit de la même marque.
export function idsDoublons(produits) {
    const groupes = {};
    (produits ?? []).forEach((p) => {
        const cle = (p.annuaire_marque_id ?? "") + "|" + normaliser(p.nom);
        (groupes[cle] = groupes[cle] || []).push(p.id);
    });
    const ids = new Set();
    Object.values(groupes).forEach((g) => {
        if (g.length > 1) g.forEach((id) => ids.add(id));
    });
    return ids;
}

export function correspondAuFiltre(produit, filtre, doublons) {
    switch (filtre) {
        case "publies":
            return Boolean(produit.isVisible);
        case "masques":
            return !produit.isVisible;
        case "sansPrestation":
            return nombrePrestations(produit) === 0;
        case "sansPhoto":
            return !aUnePhoto(produit);
        case "doublons":
            return doublons ? doublons.has(produit.id) : false;
        default:
            return true;
    }
}

export function compterFiltres(produits) {
    const doublons = idsDoublons(produits);
    const compte = {};
    FILTRES.forEach(({cle}) => {
        compte[cle] = (produits ?? []).filter((p) => correspondAuFiltre(p, cle, doublons)).length;
    });
    return compte;
}

// Produits à afficher dans la colonne du milieu.
// Sans marque choisie, on n'affiche quelque chose que si une recherche ou un filtre est actif.
export function filtrerProduits(produits, {marqueId, filtre = "tous", recherche = ""} = {}) {
    const doublons = idsDoublons(produits);
    const terme = normaliser(recherche);
    if (!marqueId && !terme && filtre === "tous") {
        return [];
    }
    return (produits ?? [])
        .filter((p) => !marqueId || p.annuaire_marque_id === marqueId)
        .filter((p) => !terme || normaliser(p.nom).includes(terme) || normaliser(p.marque?.nom).includes(terme))
        .filter((p) => correspondAuFiltre(p, filtre, doublons))
        .sort((a, b) => normaliser(a.nom).localeCompare(normaliser(b.nom)));
}

// Marques à afficher : la recherche garde les marques dont le nom ou un produit correspond.
export function filtrerMarques(marques, produits, recherche = "") {
    const terme = normaliser(recherche);
    const liste = [...(marques ?? [])].sort((a, b) => normaliser(a.nom).localeCompare(normaliser(b.nom)));
    if (!terme) return liste;
    const avecProduit = new Set(
        (produits ?? []).filter((p) => normaliser(p.nom).includes(terme)).map((p) => p.annuaire_marque_id)
    );
    return liste.filter((m) => normaliser(m.nom).includes(terme) || avecProduit.has(m.id));
}

export function compterParMarque(produits) {
    const compte = {};
    (produits ?? []).forEach((p) => {
        compte[p.annuaire_marque_id] = (compte[p.annuaire_marque_id] ?? 0) + 1;
    });
    return compte;
}

export function initiales(nom) {
    const mots = (nom ?? "").trim().split(/\s+/).filter(Boolean);
    if (mots.length === 0) return "?";
    if (mots.length === 1) return mots[0].slice(0, 2).toUpperCase();
    return (mots[0][0] + mots[1][0]).toUpperCase();
}
